import React, { memo } from "react"
import { NavLink } from "react-router-dom"

const TabItem = (props) => {
  const { to, children, base } = props;

  return (
    <li className='nav-item'>
      <NavLink
        exact
        to={`${base}${to}`}
        className='nav-link'
        activeClassName='active'
      >
        {children}
      </NavLink>
    </li>
  );
};

export default memo(TabItem)